module.exports = __webpack_public_path__ + "static/img/system.b7b7635a.png";